import { useProfiles } from '../../contexts/ProfileContext';

import { ProfileItem } from './ProfileItem';
import { ProfileSkeleton } from './ProfileSkeleton';

import { PaginationV2 } from '@/components/PaginationV2';
import { useGetCrms } from '@/hooks/useGetCrms';

export function ProfileList() {
  const { queryFilter } = useProfiles();

  const { crms, isLoading, pagination } = useGetCrms({
    name: queryFilter?.name,
    email: queryFilter?.email,
    userProfileId: queryFilter?.userProfileId,
    period: queryFilter?.period,
    spending: queryFilter?.spending,
    activeSince: queryFilter?.activeSince,
  });

  return (
    <div className="rounded-b-lg rounded-t-lg border border-gray-200">
      <ul>
        {isLoading &&
          Array.from({ length: 10 }).map((_, i) => <ProfileSkeleton key={i} />)}

        {crms.map((crm) => (
          <ProfileItem key={crm.id} crm={crm} />
        ))}
      </ul>

      <div className="p-3">
        <PaginationV2
          hasNextPage={pagination.hasNextPage}
          hasPreviousPage={pagination.hasPreviousPage}
          nextPage={pagination.nextPage}
          previousPage={pagination.previousPage}
          page={pagination.currentPage}
          totalPages={pagination.totalPages}
        />
      </div>
    </div>
  );
}
